export default __webpack_public_path__ + "static/media/window-settings.2bf2f156.svg";